import type { NodeProps } from '@xyflow/react';
import { Pencil } from 'lucide-react';
import { useT } from '../../i18n';
import type { GroupFlowNode } from '../types';

/**
 * Přerušovaný rámeček skupiny (E6-US4/US5). Vlastní drag → `CanvasView`
 * počítá deltu a volá `moveGroupCommand` — záměrně NE React Flow
 * `parentNode`/`extent`, aby vizuální obsažení neimplikovalo členství
 * (epic-6 kap. 2: členství je jen explicitní akcí).
 */
export function GroupFrameNode({ data }: NodeProps<GroupFlowNode>) {
  const t = useT();
  const { group, box, onOpenMenu, onRename } = data;

  return (
    <div
      className="group-frame"
      style={{ width: box.width, height: box.height }}
      onContextMenu={(event) => {
        event.preventDefault();
        onOpenMenu({ groupId: group.id, position: { x: event.clientX, y: event.clientY } });
      }}
    >
      <button
        type="button"
        className="group-frame__label"
        title={t('canvas.group.renameHint')}
        onDoubleClick={(event) => {
          event.stopPropagation();
          onRename(group.id);
        }}
      >
        {group.name}
        <Pencil size={12} />
      </button>
    </div>
  );
}
